import { createContext, type Context } from 'react';

import type { SideNavState } from './SideNavState';

export const SideNavContext: Context<SideNavState | undefined> =
	createContext<SideNavState | undefined>(undefined);
